import React from "react";
import PropTypes from "prop-types";
import ControlResolver from "../ControlResolver";
import { controlPropTypes } from "../formhelpers";

class Row extends React.Component {
    render() {
        const {
            descriptor,
            propsResolver,
            controlOnly
        } = this.props;
        const kids = descriptor.childItems;
        const last = kids.length > 0 && kids[kids.length - 1];
        let colsPerKid, colsForLastKid;
        if (last && last.type === "checkbox" && /missing$/.test(last.key)) {
            // reserve four-ish for the missing checkbox; distribute the rest
            colsPerKid = Math.round(8 / (kids.length - 1));
            colsForLastKid = 12 - (colsPerKid * (kids.length - 1));
        } else {
            // distributed evenly, protecting from divide-by-zero
            colsPerKid = 12 / (kids.length > 0 ? kids.length : 1);
            colsForLastKid = colsPerKid;
        }
        const Control = (
            <div className="row range-field">
                {kids.map((itemDescriptor) => {
                    const columnClass = `col-md-${itemDescriptor === last ? colsForLastKid : colsPerKid}`;
                    const controlProps = {
                        ...this.props,
                        propsResolver,
                        descriptor: itemDescriptor, // overload descriptor
                        ...propsResolver(itemDescriptor) // overload any props based on propsResolver()
                    };
                    const Control = ControlResolver(controlProps.descriptor);
                    return (
                        <div className={columnClass} key={controlProps.descriptor.key}>
                            <Control {...controlProps} controlOnly={true} />
                        </div>
                    );
                })}
            </div>
        );

        if(controlOnly) {
            return Control;
        }

        return (
            <div className="form-item">
                <div className="left-side">
                    <label>{descriptor.label}</label>
                </div>
                <div className="right-side">
                    {Control}
                </div>
            </div>
        );
    }
}

Row.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Row.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Row;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/row.js